import { Component, Input, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MenuConfigService } from "../../layouts/services/menu-config.service";
import { Router } from "@angular/router";
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  
  @Input() loadersize: any = "medium";
  @Input() fullScreen: boolean = false;
  @Input() spinnerBackgroundColor: string = "";
  height: any;

  constructor(
    private spinner: NgxSpinnerService,
    private menuService: MenuConfigService,
    private router: Router
  ) {}

  ngOnInit(): void {

    this.menuService.headerOffSetHeight.subscribe((res: any) => {
      this.height = res + "px";
    });
   
    this.spinner.show();
  }

}
